/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { go } from "@ngrx/router-store";
import { Effect, Actions, toPayload } from '@ngrx/effects';

import { Observable } from 'rxjs/Observable';
import '@api/rxjs-operators';

import { AuthenticationService } from '@api/services/authentication.service';
import { User } from '@api/models/user';

import * as fromRoot from '../app-store';

import * as user from '../actions/user.actions';
import * as ui from '../actions/ui.actions';

/**
 * Effects offer a way to isolate and easily test side-effects within your
 * application.
 * The `toPayload` helper function returns just
 * the payload of the currently dispatched action, useful in
 * instances where the current state is not necessary.
 *
 * Documentation on `toPayload` can be found here:
 * https://github.com/ngrx/effects/blob/master/docs/api.md#topayload
 *
 * If you are unfamiliar with the operators being used in these examples, please
 * check out the sources below:
 *
 * Official Docs: http://reactivex.io/rxjs/manual/overview.html#categories-of-operators
 * RxJS 5 Operators By Example: https://gist.github.com/btroncone/d6cf141d6f2c00dc6b35
 */
@Injectable()
export class UserEffects {

    constructor(
        private actions$: Actions,
        private service: AuthenticationService
    ) {}

    /**
     * Logoff user
     */
    @Effect()
    logoff$: Observable<Action> = this.actions$
        .ofType(user.LOGOFF)
        .map(() => this.service.logout())
        .do(() => go(['']))
        .map(() => new user.LogoffSuccessAction());

    /**
     * Login user
     */
    @Effect()
    login$: Observable<Action> = this.actions$
        .ofType(user.LOGIN)
        .switchMap(() => this.service.login())
        .map((u: User) => new user.LoginSuccessAction(u))
        .catch((error, caught) => Observable.of(new user.LoginFailAction(error)));

    /**
     * User was successfully logged in
     */
    @Effect()
    loginSuccess$: Observable<Action> = this.actions$
        .ofType(user.LOGIN_SUCCESS)
        .map(toPayload)
        .mergeMap((user: User) => {
            return Observable.from([
                new ui.LoadRouteAction(user),
                new ui.LoadMenuAction(user),
                new ui.LoadDashboardMenuAction()
            ]);
        });

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/effects/user.effects.ts